module.exports = "/images/jobs.svg?6c266d33b4ab5daaf0ce3699cf8db779";